import React from "react";
import { useLanguage } from "../../context/LanguageProvider";
import { languages } from "../../constants/translations";
import { LanguageInfo } from "../../types";

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const handleLanguageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setLanguage(event.target.value);
  };

  return (
    <div className="relative inline-block text-left z-50">
      <select
        id="language-select"
        value={language}
        onChange={handleLanguageChange}
        className="block w-full px-2.5 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm font-bold text-slate-700 bg-white/95 backdrop-blur-md border border-slate-200/80 rounded-xl appearance-none focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary cursor-pointer shadow-sm transition-all"
        aria-label="Select Language"
      >
        {languages.map((lang: LanguageInfo) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
